import { JDSFileUploaderItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFileUploaderItemProps>
  ): React.FC<JDSFileUploaderItemProps & { internalIndex?: number }> =>
  (props: JDSFileUploaderItemProps & { internalIndex?: number }) => {
    return (
      <Component
        {...props}
        onClick={() => {
          props.onClick?.(props.internalIndex as any);
        }}
      />
    );
  };
